import Axios from 'axios';
import UrlHelper from '../Helpers/urlHelper';

class TeachingLevelService {

    async get() {
        const response = await Axios.get(UrlHelper.buildTeachingLevelUrl(),
            { headers: { 'Content-Type': 'application/json' } }
        )
        return response.data;
    }
}

export default TeachingLevelService;